import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import React, { useState, useEffect, useRef  } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Wrapper from "../../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PaginationLink from "../../../components/Pagination/Pagination";
import ExpList from "../../../components/Expense/ExpList";
import OtherExpense from "../../../components/Expense/OtherExpense";
import "../../OperationMasterPages/ExpenseList/ExpenseList.css";
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

function ExpenseList() {
  const location = useLocation();
  const [showForm, setShowForm] = useState(false);
  const [expense_Type, setExpense_Type] = useState(null);
  const [selectedOption, setSelectedOption] =useState(location.state?.expensetype || null);
  const [fieldOpsResponse, setFieldOpsResponse] = useState(null);
  const [otherExpense, setOtherExpense] = useState(null);
  const baseAPI = process.env.REACT_APP_API_URL;
  const fileInputRef = useRef(null);
  const heading = "";
  
  //const { expensetype } = location.state || {};
  const storedToken = JSON.parse(localStorage.getItem("token"));
  const [updatedFormData, setUpdatedFormData] = useState({
    Amount: null,
    Relocation_Id: "",
    Description: "",
    Expense_Type: "",
    Job_Id: null,
    Document: "",
    Created_By: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!updatedFormData.Amount || updatedFormData.Expense_Type === "0") {
      alert("Please enter Amount and select an Expense Type.");
      return;
    }
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      try {
        const response = await axios.post(
          `${baseAPI}Userpost/AddFieldOpsExpense?ExpenseId=0`,
          updatedFormData,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        alert("Expense successfully added");
        setUpdatedFormData({
          ...updatedFormData,
          Amount: "",
          Description: "",
          Expense_Type: "",
          Document: "",
          Job_Id: "",
        });
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setShowForm(false);
      } catch (error) {
        console.error("Error posting data:", error);
      }
    }
  };

  const handleChange = (type, e) => {
    const { name, value, files } = e.target;
    if (type === "get") {
      getExpenseTypeList();
    } else {
      if (name === "Document") {
        const file = files[0];
        getUpdatedDocument(file, name);
      } else {
        setUpdatedFormData({
          ...updatedFormData,
          [name]: value,
        });
      }
    }
  };

  const handleChangeComponent = (e) => {
    setSelectedOption(e.target.value);
  };


  function getUpdatedDocument(file, name) {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const imageData = reader.result;
        setUpdatedFormData({
          ...updatedFormData,
          [name]: imageData,
        });
      };
      reader.readAsDataURL(file);
    }
  }


  function handleReset() {
    setUpdatedFormData({
      ...updatedFormData,
      Amount: "",
      Description: "",
      Expense_Type: "",
      Document: "",
      Job_Id: "",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }


  const getExpenseTypeList = async () => {
    try {
      if (storedToken) {
        const response = await axios.get(`${baseAPI}UserGet/GetFieldOpsExpenseTypeList`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });
        setExpense_Type(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching expense type list:", error);
    }
  };

  const getFieldOpsList = async () => {
    try {
      if (storedToken) {
        const response = await axios.get(`${baseAPI}UserGet/GetFieldOpsDetail?RelocationId=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });
        setFieldOpsResponse(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching field ops detail:", error);
    }
  };

  const getOtherExpenseList = async () => {
    try {
      if (storedToken) {
        const response = await axios.get(`${baseAPI}UserGet//GetOtherExpensedetail?expense_id=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });
        setOtherExpense(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching other expense detail:", error);
    }
  };

  useEffect(() => {
    getFieldOpsList();
    getExpenseTypeList();
    getOtherExpenseList();
  }, []);

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid respDiv"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Expense| <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Operations</span> {" "}
                  <span style={{ fontSize: "20px" }}>&gt; Expense</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>

              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <div className="container-fluid" style={{ marginTop: "0rem" }}>
                  <div className="headerButton">
                    <div style={{ border: "1px solid #C0C6CC", borderRadius: "16px", width: "800px", display: "none" }}  >
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }} >
                        <button style={{ height: "53px", width: "101px" }} ><FilterAltOutlinedIcon className="icon" />Filters</button>
                        <select onChange={handleChangeComponent} style={{
                          border: "1px solid #5b489d",
                          width: "30%",
                          padding: "12px",
                          borderRadius: "6px",
                          height: "45px",
                          color: "#6a6a6a",
                          position: "relative",
                        }}
                          className="form-control" >
                          <option value="ExpenseForLeadID" >Expense For Lead ID</option>
                          <option value="Other Expenses">Other Expenses</option>
                        </select>
                      </div>
                    </div>
                    <div className="button-container">
                      <button onClick={() => setShowForm(true)} >
                        <AddIcon className="icon" />Add Expense
                      </button>
                      <button>
                        <DownloadIcon className="icon" />Download Excel
                      </button>
                    </div>
                  </div>
                  <hr />
                  <div>
                    <span style={{ fontSize: "25px" }}>{heading}</span>
                  </div>
                </div>
              </Wrapper>
              <br></br>
              {showForm && (
                <>
                  <Wrapper className="ViewLeadDetails">
                    <div style={{ MarginTop: "20px" }}>
                      <h2
                        className="Venderheading"
                        style={{
                          fontSize: "22px",
                          paddingLeft: "16px",
                          paddingTop: "7px",
                        }}
                      >
                        Add Expense
                      </h2>
                      <table
                        style={{ width: "100%", marginBottom: "70px" }}
                        className="addvendorTable"
                      >
                        <tr
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                          className="tableHeading tableHeading2"
                        >
                          <td
                            style={{
                              color: "#6a6a6a",
                              fontWeight: "bold",
                              width: "100%",
                              marginTop: "13px",
                            }}
                          >
                            Amount
                          </td>
                          <td
                            style={{
                              color: "#6a6a6a",
                              fontWeight: "bold",
                              width: "100%",
                              marginTop: "13px",
                            }}
                          >
                            Description
                          </td>
                        </tr>
                        <tr
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                          className="tableHeading tableHeading2"
                        >
                          <td
                            style={{
                              color: "#6a6a6a",
                              fontWeight: "bold",
                              width: "100%",
                              marginTop: "13px",
                            }}
                          >
                            <input
                              type="number"
                              style={{
                                border: "1px solid #5b489d",
                                width: "100%",
                                padding: "12px",
                                borderRadius: "6px",
                                marginBottom: "21px",
                                marginTop: "25px",
                                height: "45px",
                                color: "#6a6a6a",
                                position: "relative",
                              }}
                              name="Amount"
                              onChange={(event) => handleChange("insert", event)}
                              value={updatedFormData.Amount}
                              placeholder="Please Enter*"
                              required
                            />
                          </td>
                          <td
                            style={{
                              color: "#6a6a6a",
                              fontWeight: "bold",
                              width: "100%",
                              marginTop: "13px",
                            }}
                          >
                            <input
                              type="text"
                              style={{
                                border: "1px solid #5b489d",
                                width: "100%",
                                padding: "12px",
                                borderRadius: "6px",
                                marginBottom: "21px",
                                marginTop: "25px",
                                height: "45px",
                                color: "#6a6a6a",
                                position: "relative",
                              }}
                              name="Description"
                              onChange={(event) => handleChange("insert", event)}
                              value={updatedFormData.Description}
                              placeholder="Please Enter*"
                              required
                            />
                          </td>
                        </tr>
                        <tr
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            marginTop: "76px",
                          }}
                          className="tableHeading tableHeading2"
                        >
                          <td
                            style={{
                              color: "#6a6a6a",
                              fontWeight: "bold",
                              width: "100%",
                              marginTop: "13px",
                            }}
                          >
                            Expense Type
                          </td>
                          <td
                            style={{
                              color: "#6a6a6a",
                              fontWeight: "bold",
                              width: "100%",
                              marginTop: "13px",
                            }}
                          >
                            Job Id
                          </td>
                        </tr>
                        <tr
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                          className="tableHeading tableHeading2"
                        >
                          <td
                            style={{
                              color: "#6a6a6a",
                              fontWeight: "bold",
                              width: "100%",
                              marginTop: "13px",
                            }}
                          >
                            <select
                              style={{
                                border: "1px solid #5b489d",
                                width: "100%",
                                padding: "12px",
                                borderRadius: "6px",
                                marginBottom: "21px",
                                marginTop: "25px",
                                height: "45px",
                                color: "#6a6a6a",
                                position: "relative",
                                marginLeft: "0px",
                              }}
                              className="form-control"
                              name="Expense_Type"
                              onChange={(event) => handleChange("insert", event)}
                              required
                              value={updatedFormData.Expense_Type}
                            >
                              <option value="0">Select an option</option>
                              {expense_Type !== null
                                ? expense_Type.map((item) => (
                                  <option key={item.Tseed} value={item.Tseed}>
                                    {item.TYPE}
                                  </option>
                                ))
                                : null}
                            </select>
                          </td>
                          <td
                            style={{
                              color: "#6a6a6a",
                              fontWeight: "bold",
                              width: "100%",
                              marginTop: "13px",
                            }}
                          >
                            {" "}
                            <input
                              type="text"
                              style={{
                                border: "1px solid #5b489d",
                                width: "100%",
                                padding: "12px",
                                borderRadius: "6px",
                                marginBottom: "21px",
                                marginTop: "25px",
                                height: "45px",
                                color: "#6a6a6a",
                                position: "relative",
                              }}
                              name="Job_Id"
                              onChange={(event) => handleChange("insert", event)}
                              value={updatedFormData.Job_Id}
                              placeholder="Please Enter*"
                              required
                            />
                          </td>
                        </tr>
                        <tr
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            marginTop: "76px",
                          }}
                          className="tableHeading tableHeading2"
                        >
                          <td
                            style={{
                              color: "#6a6a6a",
                              fontWeight: "bold",
                              width: "100%",
                              marginTop: "13px",
                            }}
                          >
                            Document
                          </td>
                        </tr>
                        <tr
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "50%",
                          }}
                          className="tableHeading tableHeading2"
                        >
                          <td
                            style={{
                              color: "#6a6a6a",
                              fontWeight: "bold",
                              width: "100%",
                              marginTop: "13px",
                            }}
                          >
                            {" "}
                            <input
                              type="file"
                              style={{
                                border: "1px solid #5b489d",
                                width: "100%",
                                padding: "7px",
                                borderRadius: "6px",
                                marginBottom: "21px",
                                marginTop: "25px",
                                height: "45px",
                                color: "#6a6a6a",
                                position: "relative",
                              }}
                              name="Document"
                              ref={fileInputRef}
                              onChange={(event) => handleChange("insert", event)}
                              placeholder="Please Enter*"
                              required
                            />
                          </td>
                        </tr>
                      </table>
                    </div>

                    <div className="reset-addCountry-button">
                      <button
                        onClick={handleSubmit}
                        type="submit"
                        style={{
                          marginRight: "4px",
                          backgroundColor: "#5B489D",
                          color: "white",
                        }}
                      >
                        Add Expense
                      </button>
                      <button
                        onClick={handleReset}
                        style={{ backgroundColor: "#F15843", color: "white" }}
                      >
                        Reset
                      </button>
                    </div>
                  </Wrapper>
                  <br></br>
                </>
              )}
              <Wrapper className="ViewLeadDetails">
                {selectedOption === "ExpenseForLeadID" ? (
                  <ExpList fieldOpsResponse={fieldOpsResponse} />
                ) : (
                  <OtherExpense fieldOpsResponse={otherExpense} />
                )}
              </Wrapper>

              <PaginationLink />

            </div>
          </div>
        </div>
      </div >
    </>
  );
}

export default ExpenseList;
